(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  const closeMegaMenu = (details) => {
    if (!details || !details.hasAttribute('open')) return;
    details.removeAttribute('open');
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  };

  const bindMegaMenuPointerClose = () => {
    document.querySelectorAll('details.mega-menu').forEach((details) => {
      if (details.dataset.hormonizeMegaPointerBound === 'true') return;
      details.dataset.hormonizeMegaPointerBound = 'true';

      const content = details.querySelector('.mega-menu__content');
      if (!content) return;

      /* Close only when the pointer leaves the mega panel itself. */
      content.addEventListener('mouseleave', (event) => {
        if (!desktopQuery.matches) return;
        const next = event.relatedTarget;
        if (next && content.contains(next)) return;
        closeMegaMenu(details);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindMegaMenuPointerClose, {
      once: true,
    });
  } else {
    bindMegaMenuPointerClose();
  }
})();
